import React from 'react'

const Leisureandentertainment = () => (
    <div>
        <div>
            <h3>Working with words</h3>
            <p className='question'>A. The words in the crossword puzzle are from the text. Find them from the text to solve the puzzle based on the clues given below.</p>
            <p><strong>Across</strong></p>
            <p>1. outdated, of or relating to the Middle Ages: <strong>Medieval</strong></p>
            <p>3. the character and atmosphere of a place: <strong>Ambience</strong></p>
            <p>6. highly decorated: <strong>Ornate</strong></p>
            <p>7. beat with a strong, regular rhythm; survive: <strong>Throb</strong></p>
            <p>10. with the agreement of all people involved: <strong>Unanimously</strong></p>
            <p>11. the destructive effects of something: <strong>Ravages</strong></p>
            <br />
            <p><strong>Down</strong></p>
            <p>1. a large city:<strong>Metropolis</strong></p>
            <p>2. wandering from place to place without any purpose:<strong>Loitering</strong></p>
            <p>4. an unpleasant place; a place of extreme misery: <strong>Hellhole</strong></p>
            <p>5. an active revolt or uprising: <strong>Insurgency</strong></p>
            <p>8. paved with cobbles: <strong>Cobbled</strong></p>
            <p>9. prosperous and growing; flourishing: <strong>Thriving</strong></p>
        </div>
        <hr/>
        <div>
            <p className='question'>B. Look up the meanings of the following words in your dictionary.</p>
            <p>Amenities: a feature that makes something more pleasant or comfortable.</p>
            <br/>
            <p>Exquisite: extremely beautiful or carefully made.</p>
            <br/>
            <p>Etiquette: the formal rules of correct or polite behavior in society or among members of a particular profession.</p>
            <br/>
            <p>Accommodation: a place to live, work or stay in; or an agreement or arrangement made to help someone.</p>
            <br/>
            <p>Mainstay: a person or thing on which something else is based or depends.</p>
            <br/>
            <p>Antique: a collectable object such as a piece of furniture or work of art that has a high value because of its age and quality.</p>
        </div>
        <div>
            <hr />
            <h3>Comprehension</h3>
            <p className='question'>Answer the following questions.</p>
            <p className='question'>a. Why did the author and his classmates decide to visit Bandipur?</p>
            <p>= The author and his classmates decided to visit Bandipur because they were tired of the busy and stressful life in Kathmandu. They wanted to take a break from the hectic city environment and enjoy the peaceful and beautiful surroundings of Bandipur.</p>

            <p className='question'>b. What is special about Bandipur?</p>
            <p>= Bandipur is special because it preserves the charm of old Nepal. It is a beautiful Newar town with cool, cobbled streets where traditional culture and lifestyle are still alive. Unlike many modern places, Bandipur offers a peaceful atmosphere that reflects Nepal's rich history and heritage.</p>

            <p className='question'>c. How has the business changed in Bandipur today?</p>
            <p>= Today, the traditional types of business in Bandipur, such as farming and local trade, have largely shifted towards tourism-related activities. Many people in Bandipur now run hotels, restaurants, and shops catering to visitors. This change has made tourism the main source of income for the town, bringing new opportunities and challenges to the local community.</p>

            <p className='question'>d. Why do the local people who have migrated to Kathmandu visit Bandipur time and again?</p>
            <p>= The local people who have moved to Kathmandu visit Bandipur again and again because they want to escape the busy and stressful life of the city. Bandipur offers them a peaceful and calm environment where they can relax and reconnect with their roots and culture. Visiting Bandipur helps them find comfort and relief from the hectic pace of urban life.</p>

            <p className='question'>e. How do the local people learn to speak English in Bandipur?</p>
            <p>= The local people in Bandipur learn to speak English by interacting with the local school children. Since the children study English at school, they help their parents and other adults practice and improve their English skills through daily conversations and communication. This way, the community gradually becomes more familiar with the language.</p>

            <p className='question'>f. What does the author mean when he says that 'time stops in the town of Bandipur'?</p>
            <p>= When the author says that “time stops in the town of Bandipur,” he means that the peaceful and timeless beauty of the town makes visitors forget about the fast pace of modern life. The natural scenery, traditional lifestyle, and calm atmosphere capture people's attention so deeply that they feel as if time has paused, allowing them to fully enjoy the moment and the town's original charm.</p>
        </div>
        <div>
            <hr />
            <h3>Critical thinking</h3>
            <p className='question'>a. The writer seems to believe that rural life is better than urban life. Do you agree with him?</p>
            <p>= Yes, I agree with the writer that rural life is better than urban life. First of all, the peaceful surroundings of the countryside attract me a lot. Villages are often described as quiet and calm places, perfect for relaxing and escaping the busy and stressful city life. Unlike cities, rural areas are less crowded with fewer people and vehicles. The natural beauty in villages is well preserved, allowing people to enjoy fresh air and a peaceful mind.</p>
            <p>This is very different from city life, where people often feel stressed and tired due to the fast pace and noise. The environment in rural areas is cleaner with less pollution because there are fewer factories and cars. While cities may offer better facilities and education, I believe that the advantages of living in the countryside such as fresh air, natural beauty, and calmness make rural life better overall.</p>
        </div>
        <hr/>
        <div>
            <p className='question'>b. Is the writer's way of looking at Bandipur just a gaze of an urban tourist? Why? Why not?</p>
            <p>= No, the writer's way of looking at Bandipur is not just the gaze of an urban tourist. He does not visit Bandipur simply as a casual traveler. Being tired of the hectic life in Kathmandu, he goes there with his friends to truly feel the peaceful environment and appreciate the natural beauty of the place with his heart.</p>
            <p>Bandipur is a hilltop town and a rural municipality in the Tanahu district of Nepal. It attracts visitors for many reasons. The genuine and original beauty of Bandipur draws most tourists, including the writer. While there, he and his friends are fascinated by the local culture, friendly people, and organic, delicious food. The writer enjoys exploring different parts of Bandipur and feels a deep connection to the place, finding the peace and refreshment he has been seeking. He also learns about the local people and their tourism businesses. The writer spends some of his best moments in Bandipur, which shows that his experience is more meaningful than just that of a typical urban tourist.</p>
        </div>
        <div>
            <hr />
            <h3>Writing</h3>
            <p className='question'>Write a letter to a business organization overseas describing the prospects of the tourism industry in your local place. Consider the following points in the letter.</p>
            <p className='question'>Propose to venture in tourism business</p>
            <p className='question'>Persuade the organization head to visit the place once.</p>
            <p className='question'>Clearly dig out the specialties and potentialities of the place.</p>
            <p className='question'>Explain its archaeological and historical importance.</p>
            <p>Parvati Gupta</p><p>
Illam-56700</p><p>
Nepal</p><p>
<br/>
2nd July 2025</p><p>
<br/>
Shamati</p><p>
Manager</p><p>
Tokyo Tourism Organization</p><p>
Tokyo, Japan</p><p>
<br/>
Subject: Proposal to Venture into Tourism Business in Illam, Nepal</p><p>
<br/>
Dear Madam,</p><p>
<br/>
I hope this letter finds you well. I am writing to introduce you to the immense tourism potential of Illam, a beautiful district in Nepal, which offers great opportunities for your esteemed organization to explore business ventures in tourism.
</p><p>
Illam is famous for its lush green tea gardens, rolling hills, and breathtaking natural scenery. The peaceful environment and fresh air make it an ideal destination for eco-tourism, hiking, and cultural experiences. The local community is warm and welcoming, eager to share the rich traditions and hospitality of this region.
</p><p>
Moreover, Illam holds significant historical and cultural importance. It is home to several ancient temples and heritage sites that reflect the rich cultural history of eastern Nepal. Visitors interested in archaeology and history will find Illam to be an engaging destination that combines natural beauty with cultural depth.
</p><p>
I kindly invite you to visit Illam and experience its unique charm yourself. A visit will give you the opportunity to explore the tourism infrastructure and meet local stakeholders who are excited to collaborate with your organization. With your expertise, I believe we can develop sustainable tourism that benefits both Illam and your organization.
</p><p>
Thank you for considering this proposal. I look forward to your positive response and the possibility of working together to unlock the full potential of tourism in Illam.
</p><p>
Yours sincerely,</p><p>
Parvati Gupta</p><p>
parvati_gupta@gmail.com</p>
        </div>
        <div>
            <hr />
            <h3>Grammar</h3>
            <p className='question'>A. Tick the correct one.
            </p>
            <p>a. He has obtained full mark/marks.</p>
             <p>marks</p>
             <br/>
            <p>b. More than two boys were/was absent.</p>
               <p>were</p>
               <br/>
            <p>c. One of the boy/boys was not found there.</p>
            <p>boys</p>
            <br/>
            <p>d. His wonder knew no bounds/bound.</p>
            <p>bounds</p>
            <br/>
            <p>e. I give you my words/word.</p>
            <p>word</p>
            <br/>
            <p>f. He gave me much/many good advice/advices.</p>
            <p>much  advice</p>
            <br/>
            <p>g. He gave wrong information/informations.</p>
            <p>information</p>
            <br/>
        <p>h. Give me two dozens/dozen eggs.</p>
        <p>dozen</p>
        <br/>
        <p>i. Six miles is/are a long distance.</p>
        <p>is</p>
        <br/>
        <p>j. The clock has struck four hours/hour.</p>
        <p>hours</p>
        <br/>

        <p>k. Would you lend me a ten rupees/rupee note?</p>
        <p>rupee</p>
        <br/>

        <p>l. Nepal government makes five year/years development plan.</p>
        <p>year</p>
        <br/>
        <p>m. They went to Singapore on a four days/day trip.</p>
        <p>day</p>
        </div>
        <hr/>
        <div>
            <p className='question'>B. Which of the sentence is correct in each pair? Rewrite the correct one.</p>
            <p>a. My all books are lost. All my books are lost.</p>
            <p>= All my books are lost.</p>
            <br/>
            <p>b. His both brothers are ill. Both his brothers are ill.</p>
            <p>= Both his brothers are ill.</p>
            <br/>
            <p>c. Give me a hundred rupee. Give a hundred rupees.</p>
            <p>= Give me a hundred rupee.</p>
            <br/>
            <p>d. Everybody except me was absent. Everybody except I was absent.</p>
            <p>= Everbody except me was absent.</p>
            <br/>
            <p>e. He was died of fever. He died of fever.</p>
            <p>= He died of fever.</p>
            <br/>
            <p>f. It is raining for a week. It has been raining for a week.</p>
            <p>= It has been raining for a week.</p>
            <br/>
            <p>g. I have seen my friend long ago. I saw my friend long ago.</p>
            <p>= I saw my friend long ago.</p>
            <br/>
            <p>h. My friend has gone out before I arrived. My friend had gone out before I arrived.</p>
            <p>= My friend had gone out before I arrived.</p>
            <br/>
            <p>i. He said he has never seen him before. He said he had never seen him before.</p>
            <p>= He said he had never seen him before.</p>
            <br/>
            <p>j. He assured he will come. He assured he would come.</p>
            <p>= He assured he would come.</p>
        </div>
    </div>
)

export default Leisureandentertainment
